import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';
import { H3 } from '../../styled/typograpghy.styled';
import rightIcon from './assets/Seen.svg';

const StyledH3 = styled(H3)`
  margin: 40px 0 16px 0;

  @media only screen and (max-width: 568px) {
    margin: 24px 0 16px 0;
    font-size: 20px;
  }
`;

const StyledP = styled.p`
  width: 382px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.color.white};
  @media only screen and (max-width: 568px) {
    width: 312px;
  }
`;

const Verification = () => (
  <FlexContainer flexDirection="column" alignItems="center">
    <img src={rightIcon} alt="right-icon" />
    <StyledH3>Application Successful</StyledH3>
    <StyledP>
      Thanks for joining Peergame Partners. We will review your application and notify you via email. Review period
      takes 24~48 hours.
    </StyledP>
  </FlexContainer>
);

export default Verification;
